(function() {
  if (window.QuickBuyInitialized) return;
  window.QuickBuyInitialized = true;

  class QuickBuy extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form[data-add-to-cart-form]');
      
      if (this.form) {
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
        
        // Add click event listener to variant buttons
        this.form.querySelectorAll('.quick-add-btn[data-variant-id]').forEach(button => {
          button.addEventListener('click', this.selectVariant.bind(this));
        });
      } else {
        console.warn('QuickBuy: Form not found. Ensure the form is present in the markup.');
      }
    }

    selectVariant(event) {
      const variantId = event.currentTarget.getAttribute('data-variant-id');
      console.log('Selected variant ID:', variantId); // Debugging log
      this.form.querySelector('#variant-id').value = variantId; // Set the hidden input value

      // Optionally, submit the form immediately after selecting a variant
      this.handleSubmit(event); // Call handleSubmit to add the selected variant to the cart
    }

    handleSubmit(event) {
      event.preventDefault();
      const formData = new FormData(this.form);
      console.log('Form data being submitted:', Array.from(formData.entries())); // Debugging log

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        console.log('Response status:', response.status); // Log response status
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        console.log('Item added to cart:', data); // Log the response data
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: data }
        }));
      })
      .catch((error) => {
        console.error('Error adding item to cart:', error);
      });
    }
  }

  if (!customElements.get('quick-buy')) {
    customElements.define("quick-buy", QuickBuy);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('quick-buy').forEach(quickBuy => {
      new QuickBuy(quickBuy);
    });
  });
})();